export const timeout = (s = 0) => {
  const delay = s ? s * 1000 : s;
  return new Promise((resolve) => setTimeout(resolve, delay));
};
